<template>
  <div id="Aircraft_Systems">
    <div class="font">
      <span class="introSubTitle"><b>机载影像边缘实时处理系统</b></span>
      <p class="textStyle">针对无人机应急应用时，由于遥感数据量多大、信息获取延时，特别是视距外应用时，无法完成数据传输，提出了基于轻量级深度卷积神经网络的在线目标识别方法，研制了机载影像边缘实时处理系统，实现了遥感数据纠正-目标检测跟踪-识别同时在线处理，实现了目标的在线实时检测与跟踪。</p>
    </div>
   <!-- <br/>   -->
    <img width="100%" src="@/assets/img/scientific/Plane.jpg" />
<!--    <p class="img_figure">森林火点在轨处理自主发现到地面用户终端耗时13秒</p>-->
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="less">
#Aircraft_Systems {
  margin-top: 20px;
   .font {
     // font-family: "Times New Roman", Times, serif;
     font-size: 14px;
     color: #454545;
   }
}
</style>
